export default __webpack_public_path__ + "static/media/iab-bottom-banner.1ac6b75c.svg";